
import { GlutenFreeFooterDrawer as NewDrawer } from "@/stable/ui-only-components/GlutenFreeFooterDrawer";
import { GlutenFreeFooterDrawer as OriginalDrawer } from "@/stable/ui-only-components-a/GlutenFreeFooterDrawer";
import { TestimonialQuizFlow } from "@/stable/ui-only-components/TestimonialQuizFlow";
import { OriginalFixedGlutenFreeFooter } from "@/components/organism/OriginalFixedGlutenFreeFooter";
import { FeatureFlagValues, FeatureFlagKeys } from "@/constants/ab-tests";

const UrlVariationComponentMap = {
    a: OriginalDrawer,
    b: NewDrawer,
    d: TestimonialQuizFlow,
    testimonial: TestimonialQuizFlow,
    'testimonial-no-trial': TestimonialQuizFlow,
    'testimonial-trial': TestimonialQuizFlow,
}

export const DrawerComponent = ({
    urlVariation,
    quizFlowControllerVariation,
    quizAiFlowVariations,
    immediateFlow,
    ...props
}) => {
    const extractedProps = {
        urlVariation,
        quizFlowControllerVariation,
        quizAiFlowVariations,
        immediateFlow,
    };

    if (urlVariation) {
        const Component = UrlVariationComponentMap[urlVariation] || UrlVariationComponentMap.b;
        return <Component {...props} {...extractedProps} />;
    }

    if (quizFlowControllerVariation !== FeatureFlagValues[FeatureFlagKeys.TT_QUIZ_FLOW_CONTROLLER].C) {
        return <OriginalFixedGlutenFreeFooter {...props} {...extractedProps} />;
    }

    if (quizAiFlowVariations.includes("flow2") || immediateFlow) {
        return <NewDrawer {...props} {...extractedProps} />;
    }

    return <OriginalDrawer {...props} {...extractedProps} />;
}